import * as I from "immutable";
import _ from "lodash";
import moment from "moment-timezone";

import {DESTINATION_TYPE} from "config/constants";
import {Destination} from "v2/api/Records";
import {apiHouse} from "v2/api/Houses";
import {apiRoute} from "v2/api/Routes";
import {apiTask} from "v2/api/Tasks";
import {apiVisitTemplate} from "v2/api/VisitTemplates";

export const apiDestination = (item) => {
  return new Destination({
    ...item,
    checkinTime: item.checkinTime && moment(item.checkinTime),
    checkoutTime: item.checkoutTime && moment(item.checkoutTime),
    duration: moment.duration(item.duration),
    estEndTime: moment(item.estimatedEndTime),
    estStartTime: moment(item.estimatedStartTime),
    externalNotes: item.notesExt,
    house: item.houseData && apiHouse(item.houseData),
    importantNotes: item.warnings,
    route: item.routeData && apiRoute(item.routeData),
    tasks: I.List((item.tasksData || []).map(apiTask)),
    schedulerNotes: item.notesScheduler,
    visitTemplate: item.visitTemplateData && apiVisitTemplate(item.visitTemplateData),
  });
};

export const canEditDuration = ({type, house}) => {
  return (type === DESTINATION_TYPE.other ||
          (type === DESTINATION_TYPE.house && !house));
};

export const getDestination = (route, id) => {
  return route.destinations.find(item => _.toString(item.id) === id);
};

export default {
  apiDestination,
  canEditDuration,
  getDestination,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Destinations.js
 **/